import { clsx } from "clsx";

import { useMediaPlayerContext } from "../media/context";
import { Text } from "../text/Text";

import "./Audio.css";

export interface AudioCaptionProps {
  direction?: "up" | "down";
}

export function AudioCaptions({ direction = "up" }: AudioCaptionProps) {
  const { captionsEnabled, captionText } = useMediaPlayerContext();

  const className = clsx("AudioCaptions", {
    [`AudioCaptions--direction-${direction}`]: !!direction,
    "AudioCaptions--collapsed": !captionsEnabled,
  });

  return captionsEnabled ? (
    <div className={className}>
      <Text>
        <span dangerouslySetInnerHTML={{ __html: captionText }} />
      </Text>
    </div>
  ) : null;
}
